import { makeStyles } from '@material-ui/core/styles';
import { amber, green } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
  success: {
    backgroundColor: green[600],
    color: theme.palette.text.primary,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    color: theme.palette.text.primary,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.primary,
  },
  warning: {
    backgroundColor: amber[700],
    color: theme.palette.text.primary,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

export default useStyles;
